import { DxError } from './dxf';

export const toErrorString = (obj) => (new DxError(obj)).toString();
